import React, { useEffect, useRef } from "react";
import "../styles/receipe_screen.scss";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import { searchText } from "../store/actions/receipeActions";
import { CLEAR_SEARCH } from "../store/constants/types";
import RecipeCard from "./layouts/RecipeCard";
import Grid from "@material-ui/core/Grid";

const ReceipeScreen = ({ history, match }) => {
  const dispatch = useDispatch();
  const receipe = useSelector((state) => state.receipe);
  const { receipes, filter, login } = receipe;
  const con = useRef(null);
  const info = receipes.find((ele) => ele.id === match.params.id);
  useEffect(() => {
    con.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    dispatch({
      type: CLEAR_SEARCH,
    });
    dispatch(searchText(info?.data?.title.slice(0, 1)));

    // eslint-disable-next-line
  }, [match.params.id]);
  return (
    <div ref={con} className="receipe_screen">
      <h2>
        <ArrowBackIcon
          onClick={() => history.push("/")}
          className="back_button"
        />
        <p>{info?.data?.title.toUpperCase()}</p>
      </h2>

      <img src={info?.data?.image} alt={info?.data?.title} />
      <div className="desc">
        <p>
          <h4>Time:</h4>
          {info?.data?.time ? info.data.time : "No Time Given"}
        </p>

        <h4>Ingredients:</h4>
        <p className="ingredients">
          {info?.data?.ingredients
            ? info.data.ingredients
            : "NO Ingredients Given"}
        </p>
        {info.data.description && <h4>Steps:</h4>}
        <p className="steps" style={{ whiteSpace: "pre-wrap" }}>
          {info?.data?.description}
        </p>
      </div>

      <div className="see-also">
        {filter?.length !== 0 && <h3>SEE ALSO</h3>}
        <Grid container spacing={3}>
          {filter?.map((doc) => (
            <RecipeCard
              key={doc.id}
              login={login}
              id={doc.id}
              receipes={doc.data}
            />
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default ReceipeScreen;
